<template>
  <btn-toggle v-model="model" :category="category" itemText="name" itemValue="value" :disabled="disabled" />
</template>

<script>
import BtnToggle from '@/components/atoms/base/button/BtnToggle'
import { InspClassCd } from '@/enum'

export default {
  name: 'BtnChooseAppDim',

  components: { BtnToggle },

  props: {
    value: {
      type: String,
      required: true,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      category: [
        { name: this.$t('ELE0211'), value: InspClassCd.APP },
        { name: this.$t('ELE0202'), value: InspClassCd.DIM },
      ],
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
